if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
      };
      this.mql = window.matchMedia('(min-width: 750px)');
      this.hardheat = document.body.classList.contains('hh-theme');
      if (!this.elements.thumbnails) return;
      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((thumbnail) => {
        thumbnail.querySelector('button').addEventListener('click', () => this.setActiveMedia(thumbnail.dataset.target, false));
      });
      if (this.hardheat) {
        this.elements.thumbnails.querySelectorAll('.slider-button').forEach((button) => {
          button.addEventListener('click', (event) => {
            event.preventDefault(); event.stopImmediatePropagation();
            const rail = this.elements.thumbnails.querySelector('.thumbnail-list');
            const direction = button.name === 'previous' ? -1 : 1;
            const target = Math.max(0, Math.min(rail.scrollHeight - rail.clientHeight, rail.scrollTop + direction * rail.clientHeight));
            if (window.HardHeatMotion) window.HardHeatMotion.scrollTo(rail, target, 300, true);
            else rail.scrollTop = target;
          }, true);
        });
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((item) => {
          item.inert = !item.classList.contains('is-active');
          item.setAttribute('aria-hidden', String(item.inert));
        });
      }
      if (this.dataset.desktopLayout?.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
    }

    onSlideChanged(event) {
      if (this.hardheat) return;
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${event.detail.currentElement.dataset.mediaId}"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) || this.elements.viewer.querySelector('[data-media-id]');
      if (!activeMedia) return;
      mediaId = activeMedia.dataset.mediaId;
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.toggle('is-active', element === activeMedia);
        if (this.hardheat) { element.inert = element !== activeMedia; element.setAttribute('aria-hidden', String(element !== activeMedia)); }
      });
      const activeThumbnail = this.elements.thumbnails?.querySelector(`[data-target="${mediaId}"]`);
      if (prepend && !this.hardheat) {
        if (activeMedia.parentElement.firstElementChild !== activeMedia) activeMedia.parentElement.prepend(activeMedia);
        if (activeThumbnail && activeThumbnail.parentElement.firstElementChild !== activeThumbnail) activeThumbnail.parentElement.prepend(activeThumbnail);
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }
      this.preventStickyHeader();
      if (!this.hardheat) {
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          const rect = activeMedia.getBoundingClientRect();
          if (rect.top < -.5) window.scrollTo({ top: rect.top + window.scrollY, behavior: 'smooth' });
        });
      }
      this.playActiveMedia(activeMedia);
      this.setActiveThumbnail(activeThumbnail);
      const position = [...this.elements.viewer.querySelectorAll('[data-media-id]')].indexOf(activeMedia) + 1;
      this.announceLiveRegion(activeMedia, position);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;
      this.elements.thumbnails.querySelectorAll('button').forEach((button) => button.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', 'true');
      if (this.hardheat) {
        const rail = this.elements.thumbnails.querySelector('.thumbnail-list');
        const bounds = rail.getBoundingClientRect();
        const rect = thumbnail.getBoundingClientRect();
        let target = rail.scrollTop;
        if (rect.top < bounds.top) target += rect.top - bounds.top;
        else if (rect.bottom > bounds.bottom) target += rect.bottom - bounds.bottom;
        if (window.HardHeatMotion) window.HardHeatMotion.scrollTo(rail, target, 300, true);
        else rail.scrollTop = target;
      } else if (!this.elements.thumbnails.isSlideVisible(thumbnail, 10)) {
        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image || !this.elements.liveRegion) return;
      const announce = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', 'false');
        this.elements.liveRegion.textContent = window.accessibilityStrings.imageAvailable.replace('[index]', position);
        clearTimeout(this.announcementTimer);
        this.announcementTimer = setTimeout(() => this.elements.liveRegion.setAttribute('aria-hidden', 'true'), 2000);
      };
      if (image.complete) announce(); else image.addEventListener('load', announce, { once: true });
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      this.stickyHeader?.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
    }

    disconnectedCallback() { clearTimeout(this.announcementTimer); }
  });
}
